import * as R from 'ramda';
// constants
import * as GC from '../constants';
// helpers
import { quickClone } from './common';
import { isNilOrEmpty, isNotNilAndNotEmpty } from './helpers';
import { setItemToWindow, getItemFromWindow, getBranchNameFromWindowByGuid } from './window';
//////////////////////////////////////////////////

// helper for set custom prop with boolean value to every item in tree
function setBoolPropToEveryTreeItem(tree, status, prop) {
  const newTree = quickClone(tree);

  if (isNotNilAndNotEmpty(newTree.children)) {
    newTree.children = newTree.children.map(
      (childrenTree) => setBoolPropToEveryTreeItem(childrenTree, status, prop),
    );
  }

  return R.assoc(prop, status, newTree);
}

// Not used
// helper for change current item boolean prop in tree
// function changeBoolPropCurrentTreeItem(
//   tree,
//   boolProp,
//   guids = null,
//   savePrevValue = false,
// ) {
//   const newTree = R.clone(tree);

//   if (R.not(R.isEmpty(tree.children))) {
//     newTree.children = newTree.children.map(
//       (childrenTree) => changeBoolPropCurrentTreeItem(childrenTree, boolProp, guids, savePrevValue),
//     );
//   }

//   const status = savePrevValue ? newTree[boolProp] : false;

//   if (isNotNil(guids) && R.includes(newTree.guid, guids)) {
//     return R.assoc(boolProp, R.not(newTree[boolProp]), newTree);
//   }

//   return R.assoc(boolProp, status, newTree);
// }

// Not used
// helper for cut tree from current branch
// function cutTreeFromCurrentBranch(
//   tree,
//   boolProp,
//   guids = null,
//   callback,
//   savePrevValue = false,
//   isCurrentChild = true,
//   currentEnt = null,
// ) {
//   let resultTree = R.clone(tree);
//   if (isNotNil(currentEnt) && R.not(isCurrentChild)) {
//     if (R.equals(resultTree.guid, currentEnt)) {
//       resultTree = cutTreeFromCurrentBranch(resultTree, boolProp, guids, callback, savePrevValue);
//     } else {
//       let findedCurrentEntTree = null;

//       if (R.not(R.isEmpty(tree.children))) {
//         resultTree.children.forEach(
//           (childrenTree) => {
//             const childTreeResult = cutTreeFromCurrentBranch(
//               childrenTree,
//               boolProp,
//               guids,
//               callback,
//               savePrevValue,
//               isCurrentChild,
//               currentEnt);
//             findedCurrentEntTree = childTreeResult || findedCurrentEntTree;
//           },
//         );
//       }
//       resultTree = findedCurrentEntTree;
//     }

//     return resultTree;
//   }

//   return callback(
//     resultTree,
//     boolProp,
//     guids,
//     savePrevValue,
//   );
// }

const getBranchFromTreeByGuid = (branchGuid, tree) => {
  if (R.propEq(branchGuid, GC.FIELD_GUID, tree)) {
    return tree;
  } else if (isNotNilAndNotEmpty(tree.children)) {
    let i;
    let result = null;

    for (i = 0; result == null && i < tree.children.length; i++) {
      result = getBranchFromTreeByGuid(branchGuid, tree.children[i]);
    }

    if (isNotNilAndNotEmpty(result)) return result;
  }
};

const getAmousBranchesObjectAndSetToGlobalWindow = (tree) => {
  const amousBranches = {};

  const setBranch = (branch) => {
    //! Don't replace this code with Ramda due to performance issues
    const children = branch.children;

    // eslint-disable-next-line no-param-reassign
    delete branch.children;

    const guid = branch[GC.FIELD_GUID];

    amousBranches[guid] = branch;

    if (children) {
      children.forEach((child) => setBranch(child));
    }
  };

  const newTree = quickClone(tree);

  setBranch(newTree);

  setItemToWindow('amousBranches', amousBranches);
};

const createBranchOptionsFromGuids = R.map((guid) => ({
  value: guid,
  label: getBranchNameFromWindowByGuid(guid),
}));

const mapBranchToOption = ({ guid, enterpriseName, enterpriseType }) => ({
  value: guid,
  label: `${enterpriseName} (${R.pathOr('', [enterpriseType], GC.branchTypeDisplayMap)})`,
});

const createBranchOptionsFromAmousBranches = () => R.compose(
  R.map(mapBranchToOption),
  R.values,
)(getItemFromWindow('amousBranches'));

const createBranchOptionsFromAmousBranchesByTypes = (types) => R.compose(
  R.map(mapBranchToOption),
  R.filter(({ enterpriseType }) => R.includes(enterpriseType, types)),
  R.values,
)(getItemFromWindow('amousBranches'));

const createBranchOptionsFromCurrentAndDown = (currentBranchGuid) => {
  const branches = getItemFromWindow('amousBranches');
  const current = R.prop(currentBranchGuid, R.or(branches, {}));

  if (isNilOrEmpty(current)) return [];

  //! Don't replace this code with Ramda due to performance issues
  const childrenByParent = {};

  Object.values(branches).forEach((branch) => {
    const parentGuid = branch[GC.FIELD_PARENT_GUID];

    if (R.isNil(parentGuid)) return;

    if (R.isNil(childrenByParent[parentGuid])) childrenByParent[parentGuid] = [];

    childrenByParent[parentGuid].push(branch);
  });

  const options = [];

  const collect = ({ guid, enterpriseName }) => {
    options.push({ value: guid, label: enterpriseName });

    const children = childrenByParent[guid];

    if (children) children.forEach(collect);
  };

  collect(current);

  return options;
};

export {
  getBranchFromTreeByGuid,
  // cutTreeFromCurrentBranch,
  setBoolPropToEveryTreeItem,
  createBranchOptionsFromGuids,
  // changeBoolPropCurrentTreeItem,
  createBranchOptionsFromAmousBranches,
  createBranchOptionsFromCurrentAndDown,
  getAmousBranchesObjectAndSetToGlobalWindow,
  createBranchOptionsFromAmousBranchesByTypes,
};
